import { createContext, useContext } from 'react'
import { type ScheduleDelayStore } from '../store/ScheduleDelayStore'

export const ScheduleDelayContext = createContext<ScheduleDelayStore | null>(null)

export const useScheduleDelayContext = () => {
  const context = useContext(ScheduleDelayContext)

  if (context === null)
    throw new Error('You have forgotten to wrap your root component with ScheduleDelayContext')

  return context
}
